import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { VehicleStatusDataInterface } from '../../models/dashboard/dashboard/vehicle-status';

interface IInitialState {
  vehicleStatus?: VehicleStatusDataInterface[];
}

const initialState: IInitialState = {
  vehicleStatus: undefined
};

const vehicleStatusSlice = createSlice({
  name: 'vehicleStatusSlice',
  initialState,
  reducers: {
    setVehicleStatus(state, action: PayloadAction<VehicleStatusDataInterface[]>) {
      state.vehicleStatus = action.payload;
    },
  },
});

export const vehicleStatusActions = vehicleStatusSlice.actions;
export default vehicleStatusSlice.reducer;
